import {Col, Modal, ModalBody, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {
  deleteAccountType,
  deleteAgeType,
  deleteEventCategory,
  deleteInventoryType,
  deleteLocation,
  deleteReferralType,
  deleteRegister,
  deleteTipType,
  getAccountTypeEventTypes,
  getAccountTypes,
  getAgeRangeTypes,
  getCashDrawers,
  getEventLocations,
  getInventoryEventTypes,
  getInventoryTypes,
  getReferralTypes,
  getTipTypes,
  saveAccountType,
  saveAgeRangeType,
  saveCashDrawer,
  saveEventLocation,
  saveInventoryEventType,
  saveInventoryType,
  saveReferralType,
  saveTipType
} from "../common/api/InventoryApi";
import {Card, Chip, NativeSelect} from "@mui/material";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Footer from "../Footer";
import ManageInventoryEventTypeModal from "../inventory/ManageInventoryEventTypeModal";
import ManageInventoryTypeModal from "../inventory/ManageInventoryTypeModal";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import {useMaterialUIController} from "../../context";
import ManageAccountTypeModal from "../inventory/ManageAccountTypeModal";
import {displayAgeRange, displayPhone, formatCurrency, handleDefaultValues} from "../common/Utils";
import {useForm} from "react-hook-form";
import {
  getCompanyCredentials,
  getCompanyExtApp,
  getCredentialTypes,
  getMyCompany,
  getPublicCompanyWaiverList,
  getStates,
  getTimeZones,
  removeCompanyEmailCredential,
  saveCompanyBranding,
  saveMyCompany,
  saveMyCompanySquareSettings,
  saveMyCompanyStripeSettings,
  uploadCompanyLogo,
  uploadTemplateFile
} from "../common/api/WebApi";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import ManageEventLocationModal from "../inventory/ManageEventLocationModal";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";
import Avatar from "@mui/material/Avatar";
import ManageAgeRangeTypeModal from "../inventory/ManageAgeRangeTypeModal";
import SortEventTypes from "../inventory/SortEventTypes";
import SortInventoryTypes from "../inventory/SortInventoryTypes";
import SortAgeRangeTypes from "../inventory/SortAgeRangeTypes";
import SortAccountTypes from "../inventory/SortAccountTypes";
import SortLocations from "../inventory/SortLocations";
import ManageCompanyDetailsModal from "./ManageCompanyDetailsModal";

import 'ckeditor5/ckeditor5.css';
import Switch from "@mui/material/Switch";
import {CONSTANTS} from "../common/constants";
import ManageReferralTypeModal from "../inventory/ManageReferralTypeModal";
import SortReferralTypes from "../inventory/SortReferralTypes";
import Divider from "@mui/material/Divider";
import SyncSquareDeviceModal from "../inventory/SyncSquareDeviceModal";
import {CompanyContext} from "../../lib/CompanyContext";
import ManageTipTypeModal from "../inventory/ManageTipTypeModal";
import QRCode from "react-qr-code";
import QrCodeIcon from '@mui/icons-material/QrCode';
import ManageEmailCredential from "../credential/ManageEmailCredential";
import {useAccess} from "../../lib/AccessProvider";
import MangeSquareHomeLocation from "../inventory/ManageSquareHomeLocation";
import ManageExtCredential from "../credential/ManageExtCredential";
import PortalBrander from "./branding/PortalBrander";
import ManageCashDrawer from "../inventory/ManageCashDrawer";
import EventPackages from "../inventory/EventPackages";

export default function CompanyCustomization(props) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);
  const [initialLoad, setInitialLoad] = useState(true);
  const env = CONSTANTS.ENVIRONMENT;

  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [showCashRegister, setShowCashRegister] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);

  const [cafeMode, setCafeMode] = useState(false);
  useEffect(() => {
    setCafeMode(companyContext?.company?.cafeEnabled || false);
    setShowCashRegister('true' === companyContext?.company?.preferences['enable_cash_register']);
  }, [companyContext?.company]);

  useEffect(() => {
    if (context?.sessionUser?.superAdmin) {
      setSuperAdmin(true);
    }
  }, [context?.sessionUser])

  const [inventoryTypes, setInventoryTypes] = useState([]);

  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);
  const [accountTypeEventTypes, setAccountTypeEventTypes] = useState([]);
  const [inventoryType, setInventoryType] = useState(null);

  const [accountTypes, setAccountTypes] = useState([]);
  const [credentialTypes, setCredentialTypes] = useState([]);
  const [referralTypes, setReferralTypes] = useState([]);
  const [ageRangeTypes, setAgeRangeTypes] = useState([]);
  const [eventLocations, setEventLocations] = useState([]);

  const [savingCompany, setSavingCompany] = useState(false);
  const [manageInventoryType, setManageInventoryType] = useState(false);
  const [sortEventTypes, setSortEventTypes] = useState(false);
  const [sortLocations, setSortLocations] = useState(false);
  const [sortAgeRangeTypes, setSortAgeRangeTypes] = useState(false);
  const [sortReferralTypes, setSortReferralTypes] = useState(false);
  const [sortAccountTypes, setSortAccountTypes] = useState(false);
  const [sortInventoryTypes, setSortInventoryTypes] = useState(false);
  const [isManageCompanyDetailsModal, setIsManageCompanyDetailsModal] = useState(false);

  const [manageInventoryEventType, setManageInventoryEventType] = useState(false);
  const [manageEventLocation, setManageEventLocation] = useState(false);

  const [eventPackage, setEventPackage] = useState(null);

  const [syncSquareDevice, setSyncSquareDevice] = useState(false);
  const [manageHomeLocation, setManageHomeLocation] = useState(false);

  const [inventoryEventType, setInventoryEventType] = useState(null);
  const [eventLocation, setEventLocation] = useState(null);
  const [confirmation, setConfirmation] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmDeletePackage, setConfirmDeletePackage] = useState(false);
  const [confirmDeleteAgeType, setConfirmDeleteAgeType] = useState(false);
  const [confirmDeleteTipType, setConfirmDeleteTipType] = useState(false);
  const [confirmDeleteReferralType, setConfirmDeleteReferralType] = useState(false);
  const [confirmDeleteRegister, setConfirmDeleteRegister] = useState(false);
  const [confirmDeleteInventoryType, setConfirmDeleteInventoryType] = useState(false);
  const [confirmDeleteCredential, setConfirmDeleteCredential] = useState(false);

  const [confirmDeleteAccountType, setConfirmDeleteAccountType] = useState(false);
  const [confirmDeleteLocation, setConfirmDeleteLocation] = useState(false);

  const [accountType, setAccountType] = useState(null);
  const [ageRangeType, setAgeRangeType] = useState(null);
  const [tipType, setTipType] = useState(null);
  const [tipTypes, setTipTypes] = useState(null);

  const [cashDrawer, setCashDrawer] = useState(null);
  const [cashDrawers, setCashDrawers] = useState(null);
  const [referralType, setReferralType] = useState(null);
  const [manageReferralType, setManageReferralType] = useState(false);

  const {getAccess} = useAccess();
  const access = getAccess();

  const [emailCredential, setEmailCredential] = useState(null);
  const [manageEmailCredential, setManageEmailCredential] = useState(false);

  const [extCredential, setExtCredential] = useState(null);
  const [manageSmsCredential, setManageSmsCredential] = useState(false);

  const [manageAccountType, setManageAccountType] = useState(false);
  const [manageAgeRangeType, setManageAgeRangeType] = useState(false);
  const [manageTipType, setManageTipType] = useState(false);
  const [manageCashDrawer, setManageCashDrawer] = useState(false);

  const [isInventoryEvent, setIsInventoryEvent] = useState(false);

  const [eventsLoading, setEventsLoading] = useState(true);

  const [init, setInit] = useState(false);

  const [company, setCompany] = useState();
  const [companyExtApplication, setCompanyExtApplication] = useState();
  const [companyReady, setCompanyReady] = useState(false);

  const [states, setStates] = useState([]);
  const [timeZones, setTimeZones] = useState([]);
  const [saving, setSaving] = useState(false);

  const [manageStripe, setManageStripe] = useState(false);
  const [manageSquare, setManageSquare] = useState(false);

  const [stripeEnabled, setStripeEnabled] = useState(false);
  const [squareEnabled, setSquareEnabled] = useState(false);

  const [reloadInventory, setReloadInventory] = useState(false);
  const [waivers, setWaivers] = useState([]);
  const [companyCredentials, setCompanyCredentials] = useState([]);

  const waiverUrl = () => {
    let waiversPart = 'waivers';
    if (env !== 'Production') {
      waiversPart = 'waivers-qa';
    }
    return 'https://' + waiversPart + '.playspacebrain.com/' + company?.subdomain;
  }


  const loadCompanyCredentials = () => {
    getCompanyCredentials().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCompanyCredentials(result);
      }
    });
  }

  const loadWaivers = () => {
    getPublicCompanyWaiverList().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setWaivers(result);
      }
    });
  }

  useEffect(() => {
    setInit(false);
    loadInventoryTypes();
    loadInventoryEventTypes();
    loadAccountTypes();
    loadCredentialTypes();
    loadCompany();
    loadStates();
    loadTimeZones();
    loadEventLocations();
    loadAgeRangeTypes();
    loadReferralTypes();
    getCompanyExtAppData();
    loadTipTypes();
    loadCashDrawers();
    loadWaivers();
    loadCompanyCredentials();
  }, []);

  const doToast = (msg) => {
    let _context = {...context};
    const toastMessage = msg ? msg : 'Settings successfully saved.';
    _context.toast = {
      message: toastMessage,
      type: 'success'
    }
    setContext({..._context});
  }

  const loadStates = () => {
    getStates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setStates(result);
      }
    });
  }

  const loadTimeZones = () => {
    getTimeZones().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTimeZones(result);
      }
    });
  }

  const addAccountTypeFn = () => {
    setAccountType(null);
    setManageAccountType(true);
  }

  const addAgeRangeTypFn = () => {
    setAgeRangeType(null);
    setManageAgeRangeType(true);
  }

  const addTipFn = () => {
    setTipType(null);
    setManageTipType(true);
  }

  const addRegisterFn = () => {
    setCashDrawer(null);
    setManageCashDrawer(true);
  }

  const manageEmailCredentialFn = (cred) => {
    setEmailCredential(cred);
    setManageEmailCredential(true);
  }

  const manageExtCredentialFn = (cred) => {
    setExtCredential(cred);
    setManageSmsCredential(true);
  }

  const addReferralTypeFn = () => {
    setReferralType(null);
    setManageReferralType(true);
  }

  const manageReferralTypeFn = (type) => {
    setReferralType(type);
    setManageReferralType(true);
  }

  const manageAgeRangeTypFn = (type) => {
    setAgeRangeType(type);
    setManageAgeRangeType(true);
  }

  const manageTipTypeFn = (type) => {
    setTipType(type);
    setManageTipType(true);
  }

  const manageRegisterFn = (type) => {
    setCashDrawer(type);
    setManageCashDrawer(true);
  }


  const loadCredentialTypes = () => {
    getCredentialTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCredentialTypes(result);
      }
    });

  }
  const loadAccountTypes = () => {
    getAccountTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAccountTypes(result);
      }
    });
  }

  const loadAgeRangeTypes = () => {
    getAgeRangeTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAgeRangeTypes(result);
      }
    });
  }

  const loadTipTypes = () => {
    getTipTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTipTypes(result);
      }
    });
  }

  const loadCashDrawers = () => {
    getCashDrawers().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCashDrawers(result);
      }
    });
  }

  const loadReferralTypes = () => {
    getReferralTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setReferralTypes(result);
      }
    });
  }

  const loadEventLocations = () => {
    getEventLocations().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventLocations(result);
      }
    });
  }

  const [hostedPortal, setHostedPortal] = useState(false);
  const [sandboxMode, setSandboxMode] = useState(false);

  const toggleHostedPortal = () => {
    setHostedPortal(!hostedPortal);
  }

  const toggleSandboxMode = () => {
    setSandboxMode(!sandboxMode);
  }

  useEffect(() => {
    setHostedPortal(!company?.hostedPortal);
  }, [company]);

  const getCompanyExtAppData = () => {
    getCompanyExtApp().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCompanyExtApplication(result);
        if (result?.type == CONSTANTS.EXT_APPLICATION.SQUARE) {
          setSquareConnected(true);
        }
      }
    });
  }
  const loadCompany = () => {
    setCompanyReady(false);
    getMyCompany().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCompany(result);
        setCompanyReady(true);
      }
    });
  }

  const loadInventoryTypes = () => {
    let _types = [];
    let _cafeTypes = [];
    getInventoryTypes().then(result => {
      _types = result;
      let merged = [..._cafeTypes, ...result]
      setInventoryTypes(merged);
    });
    getInventoryTypes(true).then(result => {
      _cafeTypes = result;
      let merged = [..._types, ...result]
      setInventoryTypes(merged);
    });
  }

  const loadAccountTypeEventTypes = () => {
    getAccountTypeEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAccountTypeEventTypes(result);
      }
    });
  }

  const loadInventoryEventTypes = () => {
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryEventTypes(result);
      }
    });
  }


  const saveCompanyDetailsFn = async (file) => {
    let result = await uploadCompanyLogo(file);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeManageCompanyDetailsFn();
      loadCompany();
    }
  }

  const saveInventoryTypeFn = async (inventoryType) => {
    let result = await saveInventoryType(inventoryType);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeInventoryTypeFn();
      loadInventoryTypes();
    }
  }

  const handleSaveEventTypesSort = async () => {
    setSortEventTypes(false);
    loadInventoryEventTypes();
  }

  const handleSaveReferralTypesSort = async () => {
    setSortReferralTypes(false);
    loadReferralTypes();
  }

  const handleSaveAgeRangeTypesSort = async () => {
    setSortAgeRangeTypes(false);
    loadAgeRangeTypes();
  }

  const handleSaveLocationsSort = async () => {
    setSortLocations(false);
    loadEventLocations();
  }

  const handleSaveAccountTypesSort = async () => {
    setSortAccountTypes(false);
    loadAccountTypes();
  }

  const handleSaveInventoryTypesSort = async () => {
    setSortInventoryTypes(false);
    loadInventoryTypes();
  }


  const saveAgeRangeTypeFn = async (ageType) => {
    let result = await saveAgeRangeType(ageType);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeAgeRangeTypeFn();
      loadAgeRangeTypes();
    }
  }

  const saveTipTypeFn = async (ageType) => {
    let result = await saveTipType(ageType);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeTipTypeFn();
      loadTipTypes();
    }
  }

  const saveCashDrawerFn = async (drawer) => {

    let result = await saveCashDrawer(drawer);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeDrawer();
      loadCashDrawers();
    }
  }

  const saveReferralTypeFn = async (type) => {
    let result = await saveReferralType(type);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeReferralTypeFn();
      loadReferralTypes();
    }
  }

  const closeAccountTypeFn = () => {
    setAccountType(null);
    setManageAccountType(false);
  }

  const closeEventLocationFn = () => {
    setEventLocation(null);
    setManageEventLocation(false);
  }

  const saveInventoryEventTypeFn = async (inventoryType) => {
    let result = await saveInventoryEventType(inventoryType);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeInventoryEventTypeFn();
      loadInventoryEventTypes();
    }
  }

  const saveAccountTypeFn = async (accountType) => {
    let result = await saveAccountType(accountType);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeAccountTypeFn();
      loadAccountTypes();
    }
  }

  const saveEventLocationFn = async (location) => {
    let result = await saveEventLocation(location);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeEventLocationFn();
      loadEventLocations();
    }
  }

  const addInventoryTypeFn = () => {
    setInventoryType(null);
    setManageInventoryType(true);
  }

  const addInventoryEventTypeFn = () => {
    manageInventoryEventTypeFn();
  }

  const addEventLocationFn = () => {
    manageEventLocationFn();
  }

  const manageAccountTypeFn = (accountType) => {
    let t = null;
    if (accountType) {
      t = {...accountType};
    }
    t.recurrencePattern = t.recurrencePattern + '';

    setAccountType(t);
    setManageAccountType(true);
  }

  const manageInventoryEventTypeFn = (inventory) => {
    let t = null;
    if (inventory) {
      t = {...inventory};
    }
    setInventoryEventType(t);
    setManageInventoryEventType(true);
  }

  const manageEventLocationFn = (location) => {
    let t = null;
    if (location) {
      t = {...location};
    }
    setEventLocation(t);
    setManageEventLocation(true);
  }

  const manageInventoryTypeFn = (type) => {
    let t = null;
    if (type) {
      t = {...type};
    }
    setInventoryType(t);
    setManageInventoryType(true);
  }

  const closeInventoryEventTypeFn = () => {
    setInventoryType(null);
    setManageInventoryEventType(false);
  }

  const closeManageCompanyDetailsFn = () => {
    setIsManageCompanyDetailsModal(false);
  }

  const closeInventoryTypeFn = () => {
    setInventoryType(null);
    setManageInventoryType(false);
  }

  const closeInventoryEventTypeSortFn = () => {
    setSortEventTypes(false);
  }

  const closeInventoryTypeSortFn = () => {
    setSortInventoryTypes(false);
  }

  const closeAgeRangeTypeSortFn = () => {
    setSortAgeRangeTypes(false);
  }

  const closeReferralTypeSortFn = () => {
    setSortReferralTypes(false);
  }

  const closeLocationsSortFn = () => {
    setSortLocations(false);
  }

  const closeAccountTypeSortFn = () => {
    setSortAccountTypes(false);
  }

  const closeAgeRangeTypeFn = () => {
    setAgeRangeType(null);
    setManageAgeRangeType(false);
  }

  const closeTipTypeFn = () => {
    setTipType(null);
    setManageTipType(false);
  }

  const closeDrawer = () => {
    setCashDrawer(null);
    setManageCashDrawer(false);
  }

  const closeReferralTypeFn = () => {
    setReferralType(null);
    setManageReferralType(false);
  }

  const handleArchiveEventCategory = async (inventory) => {
    let result = await deleteEventCategory(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDelete(false);
      loadInventoryEventTypes();
    }
  }

  const handleArchiveInventoryType = async (inventory) => {
    let result = await deleteInventoryType(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteInventoryType(false);
      loadInventoryTypes();
    }
  }

  const handleArchiveAccountType = async (inventory) => {
    let result = await deleteAccountType(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteAccountType(false);
      loadAccountTypes();
    }
  }
  const handleArchiveAgeType = async (inventory) => {
    let result = await deleteAgeType(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteAgeType(false);
      loadAgeRangeTypes();
    }
  }

  const handleArchiveTipType = async (inventory) => {
    let result = await deleteTipType(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteTipType(false);
      loadTipTypes();
    }
  }

  const handleArchiveRegister = async (inventory) => {
    let result = await deleteRegister(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteRegister(false);
      loadCashDrawers();
    }
  }

  const handleArchiveReferralType = async (inventory) => {
    let result = await deleteReferralType(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteReferralType(false);
      loadReferralTypes();
    }
  }

  const handleDeleteLocation = async (inventory) => {
    let result = await deleteLocation(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteLocation(false);
      loadEventLocations();
    }
  }

  const handleCloseDeleteInventory = () => {
    setConfirmDelete(false);
  };

  const handleCloseReferralType = () => {
    setConfirmDeleteReferralType(false);
  }

  const handleCloseAgeType = () => {
    setConfirmDeleteAgeType(false);
  }
  const handleCloseTipType = () => {
    setConfirmDeleteTipType(false);
  }

  const handleCloseRegisterType = () => {
    setConfirmDeleteReferralType(false);
  }

  const handleCloseInventoryType = () => {
    setConfirmDeleteInventoryType(false);
  };

  const handleCloseAccountType = () => {
    setConfirmDeleteAccountType(false);
  };

  const handleCloseLocation = () => {
    setConfirmDeleteLocation(false);
  }

  const handleSaveCompanyAboutUs = async (company) => {

    let _c = {...company};
    _c.aboutUs = aboutUsBody;
    setSavingCompany(true);

    setCompany({...company});
    setCompanyReady(false);
    let result = await saveMyCompany(_c);

    setSavingCompany(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      // setRefreshCompany(true);
      // setOnEdit(false);
      doToast('Company saved successfully.')
      setCompanyReady(true);
    }
  }

  const handleSaveCompanyPortalBranding = async (company, headerFooter) => {
    setSavingCompany(true);

    let result = await saveCompanyBranding(company, headerFooter);

    setSavingCompany(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      doToast('Company saved successfully.')
      loadCompany();
    }
  }

  const handleSaveCompany = async (company) => {

    setSavingCompany(true);

    let result = await saveMyCompany(company);

    setSavingCompany(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      doToast('Company saved successfully.')
      loadCompany();
    }
  }

  const handleSaveStripeSettings = async (company) => {

    setSavingCompany(true);

    let result = await saveMyCompanyStripeSettings(company);

    setSavingCompany(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      doToast('Stripe Settings saved successfully.')

      // setRefreshCompany(true);
      // setOnEdit(false);
    }
  }

  const handleSaveSquareSettings = async (company) => {

    setSavingCompany(true);

    let result = await saveMyCompanySquareSettings(company);

    setSavingCompany(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      doToast('Square Settings saved successfully.')

      // setRefreshCompany(true);
      // setOnEdit(false);
    }
  }

  const defaultvalues = {
    eventRegistrationTemplate: {
      id: -1
    }
  }

  const {register, handleSubmit, setValue} = useForm({
    values: handleDefaultValues(company)
  });

  const sidenavItems = [
    {icon: "store", label: "Company Info", href: "company-info", visible: true},
    {icon: "storefront", label: "Company Details", href: "company-details", visible: true},
    {icon: "payments", label: "Payment Settings", href: "gateway-settings", visible: true},

    {icon: "mail_lock", label: "Email Credentials", href: "external-credential-settings", visible: true},
    {icon: "language", label: "Portal Branding", href: "portal-branding-settings", visible: superAdmin},

    {icon: "sell", label: "Inventory Types", href: "inventory-types", visible: true},
    {icon: "recommend", label: "Tip Percentages", href: "tip-percentages", visible: true},

    {icon: "price_change", label: "Cash Register Locations", href: "cash-registers", visible: showCashRegister},

    {divider: true, visible: true},

    {icon: "event", label: "Event Types", href: "event-types", visible: true},
    {icon: "celebration", label: "Event Packages", href: "event-packages", visible: true},
    {icon: "room", label: "Event Locations", href: "event-locations", visible: true},
    {icon: "margin", label: "Age Ranges", href: "age-ranges", visible: true},

    {divider: true, visible: true},

    {icon: "apps", label: "Account Types", href: "account-types", visible: true},
    {icon: "chat", label: "Referral Types", href: "referral-types", visible: true},
  ];

  const confirmDeleteInventory = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDelete(true);
  }

  const confirmDeleteEmailCredential = () => {
    let confirmation = {
      title: 'Remove Email Credential?',
      message: 'Confirm archive Email Credential?',
    }
    setConfirmation(confirmation);
    setConfirmDeleteCredential(true);
  }

  const handleRemoveEmailCredentialFn = () => {
    removeCompanyEmailCredential().then((resp) => {
      loadCredentialTypes();
      loadCompanyCredentials();
      setConfirmDeleteCredential(false);
      setConfirmation(null);
    })
  }

  const confirmDeleteEventLocation = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDeleteLocation(true);
  }

  const confirmDeleteInventoryTypeFn = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDeleteInventoryType(true);
  }

  const confirmDeleteAccountTypeFn = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDeleteAccountType(true);
  }

  const confirmDeleteAgeTypeFn = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDeleteAgeType(true);
  }

  const confirmDeleteTipTypeFn = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDeleteTipType(true);
  }

  const confirmDeleteRegisterFn = (register) => {
    let confirmation = {
      title: 'Archive ' + register.name + '?',
      message: 'Confirm archive ' + register.name + '?',
      entity: register
    }
    setConfirmation(confirmation);
    setConfirmDeleteRegister(true);
  }

  const confirmDeleteReferralTypeFn = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDeleteReferralType(true);
  }

  const [portalHelp, setPortalHelp] = useState(false);
  const togglePortalHelp = () => {
    setPortalHelp(!portalHelp);
  }

  const EventCategoryActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageInventoryEventTypeFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteInventory(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const EventLocationActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageEventLocationFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteEventLocation(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const AccountTypeActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageAccountTypeFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteAccountTypeFn(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const ReferralTypeActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'referral-type-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageReferralTypeFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteReferralTypeFn(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const TipTypeActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageTipTypeFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              let _item = {...item}
              _item.name = _item.name + ' Tip Percentage';
              confirmDeleteTipTypeFn(_item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const RegisterActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'register-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageRegisterFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              let _item = {...item}
              _item.name = _item.name + ' Register Location';
              confirmDeleteRegisterFn(_item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const AgeTypeActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageAgeRangeTypFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteAgeTypeFn(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const EventTypeActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageInventoryTypeFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteInventoryTypeFn(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const displayRepeats = (item) => {
    if (item.repeatExpression) {
      let arr = item.repeatExpression.split(',');
      let days = [];
      arr.forEach((a, i) => {
        days.push(a.replace('MON', 'Monday') //
          .replace('TUE', 'Tuesday') //
          .replace('WED', 'Wednesday') //
          .replace('THU', 'Thursday') //
          .replace('FRI', 'Friday') //
          .replace('SAT', 'Saturday') //
          .replace('SUN', 'Sunday'));
      });
      if (days.length === 7) {
        return 'Repeats Daily';
      }
      return 'Repeats ' + days.join(', ');
    }
    return '';
  }

  const [stripeFormValid, setStripeFormValid] = useState(false);
  const [squareFormValid, setSquareFormValid] = useState(false);
  const [squareConnected, setSquareConnected] = useState(false);

  const [stripeForm, setStripeForm] = useState({
    stripePublicKey: '',
    stripeSecretKey: '',
    stripeWebhookSecret: ''
  });

  const [squareForm, setSquareForm] = useState({
    squareApplicationId: '',
    squareAccessToken: '',
  });

  useEffect(() => {
    if (company) {
      setStripeForm({
        stripePublicKey: company.stripePublicKey || '',
        stripeSecretKey: company.stripeSecretKey || '',
        stripeWebhookSecret: company.stripeWebhookSecret || ''
      });

      setSquareForm({
        squareApplicationId: company.squareApplicationId || '',
        squareAccessToken: company.squareAccessToken || '',
      });

      setSquareEnabled(company?.paymentExtApplicationId === CONSTANTS.EXT_APPLICATION.SQUARE);
      setStripeEnabled(company?.paymentExtApplicationId === CONSTANTS.EXT_APPLICATION.STRIPE);
    }
  }, [company]);

  useEffect(() => {
    let _stripeForm = {...stripeForm};
    let isValid = _stripeForm.stripePublicKey.length > 55 &&
      _stripeForm.stripeSecretKey.length > 55 &&
      _stripeForm.stripeWebhookSecret.length > 35;

    setStripeFormValid(isValid);

  }, [stripeForm]);

  useEffect(() => {
    let _squareForm = {...squareForm};
    let isValid = _squareForm.squareApplicationId.length > 25 &&
      _squareForm.squareAccessToken.length > 25;
    setSquareFormValid(isValid);
  }, [squareForm]);

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {

          const body = new FormData();
          loader.file.then((file) => {
            const fileType = file.type;
            const fileName = file.name;
            const reader = new FileReader();

            reader.onload = function (evt) {
              let fileRequest = {
                fileType: fileType,
                fileName: fileName,
                data: btoa(evt.target.result)
              }

              uploadTemplateFile(fileRequest).then(result => {
                if (result.error) {
                  setContext({...context, error: {message: result.message}});
                } else {
                  loader.uploaded = true;
                  loader.uploadUrl = result;
                }
                resolve({
                  default: result.fileLocation
                })
              });
            }
            reader.readAsBinaryString(file);
          });
        })
      }
    }
  }

  const [aboutUsBody, setAboutUsBody] = useState(company?.aboutUs);
  const [blurEditor, setBlurEditor] = useState();

  const insertText = (text) => {
    if (!blurEditor) {
      return;
    }
    blurEditor.model.change(writer => {
      writer.insertText(text + " ", blurEditor.model.document.selection.getFirstPosition());
      writer.setSelection(writer.createPositionAt(blurEditor.model.document.getRoot(), 'end'));
    });
  };

  useEffect(() => {
    setAboutUsBody(company?.aboutUs);
  }, [company?.aboutUs]);

  const handleChange = (e, editor) => {
    setAboutUsBody(editor.getData());
  }

  const handleReady = (editor) => {
    setBlurEditor(editor);
  };

  const handleBlur = (event, editor) => {
    setBlurEditor(editor);
  };

  const portalEmbedCode = () => {
    let envVar = '   env: \'qa\', \n';

    let _s = '<s' + 'cript id="PlaySpaceBrain">\n' +
      '  const site = { \n';
    if (env !== 'Production') {
      _s += envVar;
    }
    const companyGuid = companyContext?.company?.guid;

    _s += '   id: \'' + companyGuid + '\'\n' +
      '  } \n' +
      '  const myPlaySpaceBrain = document.createElement("script"); \n' +
      '  myPlaySpaceBrain.setAttribute("src", "https://cdn.playspacebrain.com/embed/myPlaySpaceBrain.js");\n' +
      '  document.body.appendChild(myPlaySpaceBrain);\n' +
      '</s' + 'cript>';

    return _s;
  }


  const renderSidenavItems = sidenavItems?.filter((item) => item?.visible)?.map(({
                                                                                   icon,
                                                                                   label,
                                                                                   href,
                                                                                   divider,
                                                                                   visible
                                                                                 }, key) => {
    const itemKey = `item-${key}`;

    return (
      <MDBox key={itemKey} component="li" pt={key === 0 ? 0 : 1}>
        {divider ? <Divider/> : <MDTypography
          component="a"
          href={`#${href}`}
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          sx={({
                 borders: {borderRadius},
                 functions: {pxToRem},
                 palette: {light},
                 transitions,
               }) => ({
            display: "flex",
            alignItems: "center",
            borderRadius: borderRadius.md,
            padding: `${pxToRem(10)} ${pxToRem(16)}`,
            transition: transitions.create("background-color", {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.shorter,
            }),

            "&:hover": {
              backgroundColor: light.main,
            },
          })}
        >
          <MDBox mr={1.5} lineHeight={1} color={darkMode ? "white" : "dark"}>
            <Icon fontSize="small">{icon}</Icon>
          </MDBox>
          {label}
        </MDTypography>}
      </MDBox>
    );
  });

  const doCopySnippet = () => {
    let copyText = document.getElementById("embedCopy");
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(copyText.value);
    let _context = {...context};
    _context.toast = {
      message: 'Copied to clipboard',
    }
    setContext({..._context});
  }

  const printWaiverQrCode = () => {
    const content = document.getElementById('waivers-qr-code').innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  const printPortalQrCode = () => {
    const content = document.getElementById('portal-qr-code').innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  const printPortalLoginQrCode = () => {
    const content = document.getElementById('portal-login-qr-code').innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  const portalLoginUrl = (portalUrl) => {
    let u = portalUrl;
    if (u.match('/#cx/') > -1) {
      u = u.replace('/#/cx/', '')
    }
    if (u.match('#cx/') > -1) {
      u = u.replace('#/cx/', '')
    }
    if (u.match('#cx') > -1) {
      u = u.replace('#/cx', '')
    }
    if (u.endsWith('/')) {
      return u + '#/cx/login';
    }

    return u + '/#/cx/login';
  }

  const credentialInUse = (credentials, credential) => {
    return credentials?.length > 0 && credentials.filter((cred) => cred.credentialTypeId === credential.id)[0]
  }

  return (
    <DashboardLayout>
      <Meta pageTitle={'Company Customization'}/>
      <ContextSearchNavbar title="Company Customization"/>

      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Card
              sx={{
                borderRadius: ({borders: {borderRadius}}) => borderRadius.lg,
                position: "sticky",
                top: "95px",
              }}
            >

              <MDBox
                component="ul"
                display="flex"
                flexDirection="column"
                p={2}
                m={0}
                sx={{listStyle: "none"}}
              >
                <MDTypography variant="h5" fontWeight="light">Customization Sections</MDTypography>
                <Divider/>
                {renderSidenavItems}
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} lg={9}>
            <MDBox mb={3}>

              <Grid container spacing={3}>
                <div id="company-info" style={{
                  position: 'relative',
                  left: '-999em',
                  top: '-100px'
                }}></div>
                <Grid item xs={12}>
                  <Card>
                    <MDBox p={3}>

                      <h5 className={'mb-2'}>
                        Company Info
                      </h5>

                      {companyReady && <>

                        <form onSubmit={handleSubmit(handleSaveCompany)} id={'companyForm'}>

                          <Row style={{
                            marginTop: '-25px'
                          }}>
                            <Col xs={12}>
                              <label className={'form-check-label cursor-pointer pull-right'}
                                     htmlFor="sandboxMode">
                                <Switch
                                  style={{marginRight: '5px'}}
                                  role={'switch'}
                                  defaultChecked={company?.sandboxMode}
                                  {...register('sandboxMode',
                                    {
                                      onChange: (e) => {
                                        toggleSandboxMode()
                                      }
                                    })}
                                  id="sandboxMode"/>
                                &nbsp;Onboard Mode</label>
                            </Col>
                          </Row>

                          <Row>
                            <Col className={'col'} sm={4} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('companyName')}
                                  autoComplete="off" disabled
                                  className="form-control" id="companyName"
                                  label="Enter Company Name"/>
                              </div>
                            </Col>

                            <Col className={'col'} sm={4} xs={12}>
                              <div className="form-group">

                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('subdomain')}
                                  autoComplete="off" disabled
                                  className="form-control" id="subdomain"
                                  label="Subdomain"/>
                              </div>
                            </Col>


                            <Col className={'col'} sm={4} xs={12}>
                              <div className="form-group">
                                {timeZones?.length && <NativeSelect
                                  variant="outlined" required
                                  id={'timeZone'} name={'timeZone'} className={'form-control'}
                                  {...register('timeZone.id')}>
                                  {
                                    timeZones.map((c) =>
                                      <option value={c.id} key={c.id}>
                                        {c.displayName}
                                      </option>)
                                  }
                                </NativeSelect>}

                              </div>
                            </Col>

                          </Row>
                          <Row className={'pt-2'}>
                            <Col className={'col'} md={6} sm={12} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('website')}
                                  autoComplete="off"
                                  className="form-control" id="website"
                                  label="Website"/>
                              </div>
                            </Col>

                            <Col className={'col'} md={6} sm={12} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('primaryPhone', {
                                    onChange: (e) => {
                                      e.target.value = displayPhone(e.target.value);
                                    }
                                  })}
                                  autoComplete="off"
                                  className="form-control" id="primaryPhone"
                                  label="Enter Phone"/>
                              </div>
                            </Col>
                          </Row>
                          <Row className={'pt-2'}>
                            <Col className={'col'} sm={6} xs={12}>
                              <div className="form-group">

                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('address1')}
                                  autoComplete="off"
                                  className="form-control" id="address1"
                                  label="Enter Address"/>

                              </div>
                            </Col>

                            <Col className={'col'} sm={6} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('address2')}
                                  autoComplete="off"
                                  className="form-control" id="address2"
                                  label="Enter Address 2"/>
                              </div>
                            </Col>
                          </Row>
                          <Row className={'pt-2'}>
                            <Col className={'col'} sm={4} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}

                                  variant="standard" type="text"
                                  {...register('city')}
                                  autoComplete="off"
                                  className="form-control" id="city"
                                  label="Enter City"/>
                              </div>
                            </Col>

                            <Col className={'col'} sm={4} xs={12}>
                              <div className="form-group">
                                {states?.length && <NativeSelect
                                  variant="outlined"
                                  id={'state'} name={'state'} className={'form-control'}
                                  {...register('state.stateId')}>
                                  {
                                    states.map((c) =>
                                      <option value={c.stateId} key={c.stateId}>
                                        {c.stateName}
                                      </option>)
                                  }
                                </NativeSelect>}

                              </div>
                            </Col>

                            <Col className={'col'} sm={4} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}

                                  variant="standard" type="text"
                                  {...register('postalCode')}
                                  autoComplete="off"
                                  className="form-control" id="postalCode"
                                  label="Enter Zip"/>
                              </div>
                            </Col>
                          </Row>

                          <Row className={'pt-2'}>
                            <Col className={'col'} md={6} sm={12} xs={12}>
                              <div className="form-group">
                                <b>Public Member Portal&nbsp;

                                  <a href={'#'} onClick={(e) => {
                                    e.preventDefault();
                                    printPortalQrCode();
                                  }}>
                                    <QrCodeIcon/>
                                  </a></b>
                                <MDTypography variant="p" fontWeight="medium">
                                  <br/>
                                  <a href={company?.portalUrl} target="_blank">
                                    <Icon>launch</Icon>{company?.portalUrl}
                                  </a>
                                </MDTypography>
                              </div>
                              <div style={{
                                display: 'none'
                              }}>
                                <div id="portal-qr-code">
                                  <div style={{
                                    width: '40%',
                                    margin: '10px 0'
                                  }}>
                                    <QRCode
                                      size={256}
                                      style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                      value={company?.portalUrl}
                                      viewBox={'0 0 256 256'}/>
                                  </div>
                                </div>
                              </div>


                              <div className="form-group">
                                <b>Public Member Login&nbsp;

                                  <a href={'#'} onClick={(e) => {
                                    e.preventDefault();
                                    printPortalQrCode();
                                  }}>
                                    <QrCodeIcon/>
                                  </a></b>
                                <MDTypography variant="p" fontWeight="medium">
                                  <br/>
                                  <a href={portalLoginUrl(company?.portalUrl)} target="_blank">
                                    <Icon>launch</Icon>{portalLoginUrl(company?.portalUrl)}
                                  </a>
                                </MDTypography>
                              </div>
                              <div style={{
                                display: 'none'
                              }}>
                                <div id="portal-login-qr-code">
                                  <div style={{
                                    width: '40%',
                                    margin: '10px 0'
                                  }}>
                                    <QRCode
                                      size={256}
                                      style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                      value={portalLoginUrl(company?.portalUrl)}
                                      viewBox={'0 0 256 256'}/>
                                  </div>
                                </div>
                              </div>


                              <div className="form-group">
                                <b>Public Waivers & Contracts&nbsp;
                                  <a href={'#'} onClick={(e) => {
                                    e.preventDefault();
                                    printWaiverQrCode();
                                  }}>
                                    <QrCodeIcon/>
                                  </a>
                                </b>
                                <MDTypography variant="p" fontWeight="medium">
                                  <br/>
                                  <a href={waiverUrl()} target="_blank">
                                    <Icon>launch</Icon>{waiverUrl()}
                                  </a>
                                </MDTypography>
                              </div>
                              <div style={{
                                display: 'none'
                              }}>
                                <div id="waivers-qr-code">
                                  <div style={{
                                    width: '40%',
                                    margin: '10px 0'
                                  }}>
                                    <QRCode
                                      size={256}
                                      style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                      value={waiverUrl()}
                                      viewBox={'0 0 256 256'}/>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col className={'col'} md={6}>
                              <label className={'form-check-label cursor-pointer'} htmlFor="hostedPortal">
                                <Switch
                                  style={{marginRight: '5px'}}
                                  role={'switch'}
                                  defaultChecked={company?.hostedPortal || false}
                                  {...register('hostedPortal',
                                    {
                                      onChange: (e) => {
                                        toggleHostedPortal()
                                      }
                                    })}
                                  id="hostedPortal"/>
                                &nbsp;Self Hosted Portal</label>&nbsp;<span
                              onClick={() => {
                                togglePortalHelp()
                              }}
                              className={'cursor-pointer text-info fa fa-info-circle'}></span>
                              <MDInput
                                InputLabelProps={{shrink: true}}
                                className="mt-2"
                                variant="standard" type="text"
                                {...register('hostedPortalUrl', {
                                  disabled: hostedPortal
                                })}
                                autoComplete="off"
                                className="form-control" id="hostedUrl"
                                label="Enter Self Hosted Portal Url"/>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <MDButton className={'mt-2 pull-right'}
                                        type="submit"
                                        variant="gradient"
                                        size={'small'}
                                        disabled={savingCompany}
                                        color="info">
                                {savingCompany ? 'Saving' : 'Save'}
                              </MDButton>
                            </Col>
                          </Row>
                        </form>
                      </>
                      }
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <div id="company-details" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      {company &&
                        <form onSubmit={handleSubmit(handleSaveCompanyAboutUs)} id={'companyAboutUsForm'}>
                          <Row>
                            <Col>
                              <MDTypography variant="h5"
                                            fontWeight="medium">
                                Company Details
                              </MDTypography>
                              <p className={'py-2 fw-light'}>
                                Use these fields for other public customer-facing information.
                              </p>

                              <MDInput
                                InputLabelProps={{shrink: true}}
                                className="mt-2"
                                variant="standard" type="text"
                                {...register('defaultLocation')}
                                autoComplete="off"
                                className="form-control" id="defaultLocation"
                                label="Enter Display Location"/>

                              <MDInput
                                InputLabelProps={{shrink: true}}
                                sx={{
                                  marginTop: '20px'
                                }}
                                variant="standard" type="text"
                                {...register('contactPhone', {
                                  onChange: (e) => {
                                    e.target.value = displayPhone(e.target.value);
                                  }
                                })}
                                autoComplete="off"
                                className="form-control" id="contactPhone"
                                label="Enter Contact Phone"/>

                              <MDInput
                                sx={{
                                  marginTop: '20px'
                                }}
                                InputLabelProps={{shrink: true}}
                                className="mt-2"
                                variant="standard" type="email"
                                {...register('emailFrom')}
                                autoComplete="off"
                                className="form-control" id="emailFrom"
                                label="Enter From Email"/>
                            </Col>
                          </Row>

                          <Row>
                            <Col className={'col mt-2'} sm={6} xs={12}>
                              <b>General Liability Waiver</b>
                              <div className="form-group">
                                <NativeSelect
                                  variant="outlined"
                                  id={'generalWaiverGk'} name={'generalWaiverGk'} className={'form-control'}
                                  {...register('generalWaiverGk')}>
                                  <option value={-1}>Choose</option>
                                  {
                                    waivers?.map((c) =>
                                      <option value={c.id} key={c.id}>
                                        {c.waiverName}
                                      </option>)
                                  }
                                </NativeSelect>

                              </div>
                              <Divider/>
                              <b>Company Logo</b>
                              <div className="form-group">
                                {company?.logoUrl &&
                                  <>
                                    <img
                                      className={'my-2 d-block img-thumbnail'} src={company?.logoUrl} alt="img"/>
                                  </>
                                }
                                <MDButton
                                  color="secondary"
                                  size="small"
                                  className="d-block p-2"
                                  onClick={() => {
                                    setIsManageCompanyDetailsModal(true);
                                  }}>Upload Logo</MDButton>

                              </div>
                            </Col>

                          </Row>

                          <Row>
                            <Col>
                              <MDButton className={'mt-2 pull-right'}
                                        type="submit"
                                        variant="gradient"
                                        size={'small'}
                                        disabled={savingCompany}
                                        color="info">
                                {savingCompany ? 'Saving' : 'Save'}
                              </MDButton>
                            </Col>
                          </Row>

                        </form>
                      }
                    </MDBox>

                  </Card>
                </Grid>

                {superAdmin &&
                  <Grid item xs={12}>
                    <div id="portal-branding-settings" style={{
                      position: 'relative',
                      left: '-999em',
                      zIndex: '-999',
                      top: '-100px'
                    }}/>
                    <Card>
                      <MDBox p={3}>
                        <h5>
                          Portal Branding
                        </h5>

                        <p className={'pb-2 fw-light'}>
                          Customize Portal Branding for Play Space Brain hosted portals.
                        </p>
                        {company && <>
                          <Row className={'mt-2'}>
                            <Col className={'col'} sm={12} xs={12}>
                              <h6>Portal Header</h6>
                              <PortalBrander header={true} footer={false} data={company?.portalHeader}
                                             onSave={(data) => {
                                               let _c = {...company};
                                               _c.portalHeader = data;
                                               handleSaveCompanyPortalBranding(_c, 'header');
                                             }}/>
                            </Col>
                          </Row>
                          <Divider/>
                          <Row className={'mt-2'}>
                            <Col className={'col'} sm={12} xs={12}>
                              <h6>Portal Footer</h6>
                              <PortalBrander header={false} footer={true} data={company?.portalFooter}
                                             onSave={(data) => {
                                               let _c = {...company};
                                               _c.portalFooter = data;
                                               handleSaveCompanyPortalBranding(_c, 'footer');
                                             }}/>
                            </Col>
                          </Row>
                        </>
                        }

                      </MDBox>
                    </Card>
                  </Grid>
                }

                <Grid item xs={12}>
                  <div id="external-credential-settings" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        External Email Credentials

                        <MDButton className={'mt-2 pull-right'}
                                  type="button"
                                  size={'small'}
                                  color="primary"
                                  onClick={(e) => {
                                    manageEmailCredentialFn(credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.EMAIL}));
                                  }}>
                          Manage
                        </MDButton>

                      </h5>

                      <p className={'pb-2 fw-light'}>
                        Enter Email Credentials to send emails where smtp relay is supported.
                        <br/>
                        Notes: SMTP must be enabled. If your email account uses 2-factor authentication, you must use an
                        app password.
                      </p>

                      <Row className={'mt-2'}>
                        <Col className={'col'} sm={12} xs={12}>
                          <table className={'table table-striped table-hover'}>
                            <thead>
                            <tr>
                              <th>Name</th>
                              <th>Auth</th>
                              <th>In Use</th>
                              <th scope="col" className="text-right">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.EMAIL}) && <>
                              <tr>
                                <td>Email</td>
                                <td>
                                  {credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.EMAIL})?.authKey || ''}
                                </td>
                                <td>
                                  {credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.EMAIL}) &&
                                  !credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.EMAIL}).disabled ? 'Yes' : 'No'}
                                </td>
                                <td className={'text-right'}>

                                  <MDButton className={'mt-2 pull-right mx-1'}
                                            type="button"
                                            size={'small'}
                                            onClick={(e) => {
                                              confirmDeleteEmailCredential()
                                            }}
                                            color="info">
                                    Remove
                                  </MDButton>
                                </td>
                              </tr>
                            </>}
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                    </MDBox>
                  </Card>
                </Grid>


                {/*<Grid item xs={12}>*/}
                {/*  <div id="external-credential-settings" style={{*/}
                {/*    position: 'relative',*/}
                {/*    left: '-999em',*/}
                {/*    zIndex: '-999',*/}
                {/*    top: '-100px'*/}
                {/*  }}/>*/}
                {/*  <Card>*/}
                {/*    <MDBox p={3}>*/}
                {/*      <h5>*/}
                {/*        External SMS Credentials COMING SOON! */}

                {/*        <MDButton className={'mt-2 pull-right'}*/}
                {/*                  type="button"*/}
                {/*                  size={'small'}*/}
                {/*                  color="primary"*/}
                {/*                  onClick={(e) => {*/}
                {/*                    manageExtCredentialFn(credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.SMS}));*/}
                {/*                  }}>*/}
                {/*          Manage*/}
                {/*        </MDButton>*/}

                {/*      </h5>*/}

                {/*      <p className={'pb-2 fw-light'}>*/}
                {/*        Enter SMS Credentials to send text messages.*/}
                {/*      </p>*/}

                {/*      <Row className={'mt-2'}>*/}
                {/*        <Col className={'col'} sm={12} xs={12}>*/}
                {/*          <table className={'table table-striped table-hover'}>*/}
                {/*            <thead>*/}
                {/*            <tr>*/}
                {/*              <th>Name</th>*/}
                {/*              <th>Auth</th>*/}
                {/*              <th>In Use</th>*/}
                {/*              <th scope="col" className="text-right">Actions</th>*/}
                {/*            </tr>*/}
                {/*            </thead>*/}
                {/*            <tbody>*/}
                {/*            {credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.SMS}) && <>*/}
                {/*              <tr>*/}
                {/*                <td>{credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.SMS})?.host}</td>*/}
                {/*                <td>*/}
                {/*                  {credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.SMS})?.authKey || ''}*/}
                {/*                </td>*/}
                {/*                <td>*/}
                {/*                  {credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.SMS}) &&*/}
                {/*                  !credentialInUse(companyCredentials, {id: CONSTANTS.EXT_CREDENTIAL.SMS}).disabled ? 'Yes' : 'No'}*/}
                {/*                </td>*/}
                {/*                <td className={'text-right'}>*/}

                {/*                  <MDButton className={'mt-2 pull-right mx-1'}*/}
                {/*                            type="button"*/}
                {/*                            size={'small'}*/}
                {/*                            onClick={(e) => {*/}
                {/*                              confirmDeleteEmailCredential()*/}
                {/*                            }}*/}
                {/*                            color="info">*/}
                {/*                    Remove*/}
                {/*                  </MDButton>*/}
                {/*                </td>*/}
                {/*              </tr>*/}
                {/*            </>}*/}
                {/*            </tbody>*/}
                {/*          </table>*/}
                {/*        </Col>*/}
                {/*      </Row>*/}
                {/*    </MDBox>*/}
                {/*  </Card>*/}
                {/*</Grid>*/}

                <Grid item xs={12}>
                  <div id="gateway-settings" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Payment Settings
                      </h5>

                      <p className={'pb-2 fw-light'}>
                        Payment Gateways are required to process payments and manage subscriptions.
                      </p>

                      <Row className={'mt-2'}>
                        <Col className={'col'} sm={6} xs={12}>
                          <b>
                            Choose Payment Gateway
                          </b>
                          <div className="form-group">
                            {company && <NativeSelect
                              onChange={(e) => {
                                setStripeEnabled(parseInt(e.target.value, 10) === 2);
                                setSquareEnabled(parseInt(e.target.value, 10) === 1);
                                let _c = {...company}
                                _c.paymentExtApplicationId = parseInt(e.target.value, 10);
                                setCompany({..._c});
                              }}
                              value={company?.paymentExtApplicationId || -1}
                              variant="outlined"
                              id={'paymentGateway'} name={'paymentGateway'} className={'form-control'}>
                              <option value={-1}>None</option>
                              <option value={1}>Square</option>
                              <option value={2}>Stripe</option>
                            </NativeSelect>}
                          </div>
                        </Col>
                      </Row>

                      {company && stripeEnabled &&
                        <form onSubmit={handleSubmit(handleSaveStripeSettings)} id={'companyStripeForm'}>

                          <Row className={'pt-2'}>
                            <Col className={'col'} md={12} sm={12} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('stripePublicKey', {
                                    onChange: (e) => {
                                      setStripeForm({
                                        ...stripeForm,
                                        stripePublicKey: e.target.value
                                      });
                                    }
                                  })}
                                  placeholder="pk_************"
                                  autoComplete="off"
                                  className="form-control" id="stripePublicKey"
                                  label="Enter Publishable Key"/>
                              </div>
                            </Col>

                            <Col className={'col'} md={12} sm={12} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="password"
                                  {...register('stripeSecretKey', {
                                    onChange: (e) => {
                                      setStripeForm({
                                        ...stripeForm,
                                        stripeSecretKey: e.target.value
                                      });
                                    }
                                  })}
                                  placeholder="sk_************"
                                  autoComplete="off"
                                  className="form-control" id="stripeSecretKey"
                                  label="Enter Secret Key"/>
                              </div>
                            </Col>

                            <Col className={'col'} md={12} sm={12} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  variant="standard" type="text"
                                  InputLabelProps={{shrink: true}}
                                  {...register('stripeWebhookSecret', {
                                    onChange: (e) => {
                                      setStripeForm({
                                        ...stripeForm,
                                        stripeWebhookSecret: e.target.value
                                      });
                                    }
                                  })}
                                  placeholder="whsec_************"
                                  autoComplete="off"
                                  className="form-control" id="stripeWebhookSecret"
                                  label="Enter Webhook Signing Secret"/>
                              </div>
                            </Col>

                          </Row>

                          <Row>
                            <Col>
                              <MDButton className={'mt-2 pull-right'}
                                        type="submit"
                                        variant="gradient"
                                        size={'small'}
                                        disabled={!stripeFormValid || savingCompany}
                                        color="info">
                                {savingCompany ? 'Saving' : 'Save'}
                              </MDButton>
                            </Col>
                          </Row>

                        </form>}

                      {company && squareEnabled &&
                        <form onSubmit={handleSubmit(handleSaveSquareSettings)} id={'companyStripeForm'}>

                          <Row className={'pt-2'}>
                            <Col className={'col'} md={12} sm={12} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('squareApplicationId', {
                                    onChange: (e) => {
                                      setSquareForm({
                                        ...squareForm,
                                        squareApplicationId: e.target.value
                                      });
                                    }
                                  })}
                                  placeholder="square-application-id-sq00************"
                                  autoComplete="off"
                                  className="form-control" id="squareApplicationId"
                                  label="Enter Application Id"/>
                              </div>
                            </Col>

                            <Col className={'col'} md={12} sm={12} xs={12}>
                              <div className="form-group">
                                <MDInput
                                  InputLabelProps={{shrink: true}}
                                  variant="standard" type="text"
                                  {...register('squareAccessToken', {
                                    onChange: (e) => {
                                      setSquareForm({
                                        ...squareForm,
                                        squareAccessToken: e.target.value
                                      });
                                    }
                                  })}
                                  placeholder="SQUA123************"
                                  autoComplete="off"
                                  className="form-control" id="squareAccessToken"
                                  label="Enter Secret Key"/>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <MDButton className={'mt-2 pull-right'}
                                        type="submit"
                                        variant="gradient"
                                        size={'small'}
                                        disabled={!squareFormValid || savingCompany}
                                        color="info">
                                {savingCompany ? 'Saving' : 'Save'}
                              </MDButton>
                            </Col>
                          </Row>
                          <Divider/>

                          {companyExtApplication?.connected && <>
                            <MDTypography variant="h6" className={'mb-2'}>
                              Square Locations <MDButton className={'mt-2 pull-right'}
                                                         type="button"
                                                         size={'small'}
                                                         onClick={() => {
                                                           setSyncSquareDevice(true);
                                                         }}
                                                         color="primary">
                              Sync Point of Sale Device
                            </MDButton>

                              <MDButton className={'mt-2 pull-right mx-2'}
                                        type="button"
                                        size={'small'}
                                        onClick={() => {
                                          setManageHomeLocation(true);
                                        }}
                                        color="primary">
                                Set Home Location
                              </MDButton>
                            </MDTypography>

                            {companyExtApplication?.currentLocations?.length > 0 &&
                              <table className="table table-striped mt-2">
                                <thead>
                                <tr>
                                  <th scope="col">Location Name</th>
                                  <th scope="col">Device Synced</th>
                                  <th scope="col">Default</th>
                                </tr>
                                </thead>
                                <tbody>
                                {companyExtApplication?.currentLocations?.map((a, idx) => {
                                  return (
                                    <tr key={idx}>
                                      <td>
                                        {a.name}
                                      </td>
                                      <td>
                                        {a.connected ? "Yes" : "No"}
                                      </td>
                                      <td>
                                        {a.defaultLocation ? "Yes" : "No"}
                                      </td>
                                    </tr>
                                  )
                                })}
                                </tbody>
                              </table>
                            }
                          </>
                          }

                        </form>}

                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <div id="inventory-types" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Inventory Types
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addInventoryTypeFn();
                          }}>
                          <Icon>sell</Icon>&nbsp;Add Inventory Type
                        </MDButton>

                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right mx-2'}
                          onClick={(e) => {
                            setSortInventoryTypes(true);
                          }}>
                          <Icon>sort</Icon>&nbsp;Sort Inventory Types
                        </MDButton>

                      </h5>
                      <p className={'py-2 fw-light'}>
                        Use inventory types to define general categories of inventory. For example, you
                        might have inventory types for "Food", "Beverage", "Toys", "Memberships", etc.
                      </p>
                      <ul className={'list-group'}>
                        {inventoryTypes
                          .map((type, index) => {
                            return (
                              <li
                                className={'list-group-item'}
                                key={index}>
                                {type.id &&
                                  <>
                                <span className="d-block pull-right">
                                    <EventTypeActions item={type}/>
                                  </span>
                                    <a
                                      href={'#'}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        manageInventoryTypeFn(type);
                                      }}>{type.name}</a>
                                  </>
                                }
                                {type.desc && <>
                                  <small className={'text-small my-n2'}><br/>{type.desc}</small>
                                </>}
                                <br/>

                                {type.partyItem && <>
                                  <Chip variant="outlined"
                                        color="primary" label={<><Icon>celebration</Icon> Party Item</>}/>&nbsp;
                                </>}
                                {type.cafeItem && <>
                                  <Chip
                                    variant="outlined"
                                    color="secondary" label={<><Icon>fastfood</Icon> Cafe Item</>}/>&nbsp;
                                </>}
                                <Chip
                                  variant="outlined"
                                  color="secondary" label={<><Icon>gavel</Icon> Sales Tax {type?.salesTax}%</>}/>
                                &nbsp;

                              </li>
                            );
                          })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <div id="tip-percentages" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Tip Percentages
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addTipFn();
                          }}>
                          <Icon>recommend</Icon>&nbsp;Add Tip Option
                        </MDButton>
                      </h5>
                      <p className={'py-2 fw-light'}>
                        Set default tip percentages that appear during checkout when tipping is enabled for your store,
                        cafe, and events.
                      </p>
                      <ul className={'list-group'}>
                        {tipTypes?.length > 0 && tipTypes?.sort((a, b) => a.sortOrder - b.sortOrder).map((type, index) => {
                          return (
                            <li
                              className={'list-group-item '}
                              key={index}>
                                <span className="d-block pull-right">
                                    <TipTypeActions item={type}/>
                                  </span>
                              <a
                                href={'#'}
                                onClick={(e) => {
                                  e.preventDefault();
                                  manageTipTypeFn(type);
                                }}>{type.tipPercentage}%</a>
                            </li>
                          );
                        })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>

                {showCashRegister && <Grid item xs={12}>
                  <div id="cash-registers" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Cash Register Locations
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addRegisterFn();
                          }}>
                          <Icon>recommend</Icon>&nbsp;Add Register Location
                        </MDButton>
                      </h5>
                      <p className={'py-2 fw-light'}>
                        Set Cash Register Locations to track cash register balances, ie. Front of House, Back of House,
                        External.
                      </p>
                      <ul className={'list-group'}>
                        {cashDrawers?.length > 0 && cashDrawers?.sort((a, b) => a.id - b.id)
                          .map((type, index) => {
                            return (
                              <li
                                className={'list-group-item '}
                                key={index}>
                                <span className="d-block pull-right">
                                    <RegisterActions item={type}/>
                                  </span>
                                <a
                                  href={'#'}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setCashDrawer(type);
                                    setManageCashDrawer(true);
                                  }}>{type.name}</a>
                              </li>
                            );
                          })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>
                }

                <Grid item xs={12}>
                  <div id="event-types" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Event Types
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addInventoryEventTypeFn();
                          }}>
                          <Icon>event</Icon>&nbsp;Add Event Type
                        </MDButton>

                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right mx-2'}
                          onClick={(e) => {
                            setSortEventTypes(true);
                          }}>
                          <Icon>sort</Icon>&nbsp;Sort Event Types
                        </MDButton>

                      </h5>
                      <p className={'py-2 fw-light'}>
                        Use event types to define general categories of inventory events. For example, you might
                        have
                        event types for "Open Play", "Classes", "Member-Only Events", "Birthday Parties", etc.
                      </p>
                      <ul className={'list-group'}>
                        {inventoryEventTypes?.length > 0 && inventoryEventTypes.map((type, index) => {
                          return (
                            <li
                              className={'list-group-item '}
                              key={index}>
                              {type.id && type.name &&
                                <>
                                  <span className="d-block pull-right">
                                    <EventCategoryActions item={type}/>
                                  </span>
                                  {type.backgroundColor && <span style={{
                                    background: type.backgroundColor,
                                    width: '15px',
                                    height: '15px',
                                    float: 'left',
                                    margin: '4px 2px 2px 0'
                                  }}>
                                  </span>}
                                  <a
                                    href={'#'}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      manageInventoryEventTypeFn(type);
                                    }}>{type.name}
                                  </a>
                                </>
                              }
                              <small className={'text-small my-n2 d-block'}>
                                {type.desc} <br/>
                                {type?.hideEndTime && <Chip
                                  avatar={<Avatar><Icon>watch_off</Icon></Avatar>}
                                  size="small"
                                  variant={'outlined'}
                                  className={'m-1 mb-n1'}
                                  label={'End Time Hidden'}
                                  color="default"/>
                                }
                              </small>

                              <MDTypography variant="small" fontWeight={"light"}>Notifications</MDTypography>
                              <br/>
                              <Chip
                                avatar={<Avatar><Icon>email</Icon></Avatar>}
                                size="small"
                                variant={'outlined'}
                                className={'m-1 mb-n1'}
                                label={'Booking: ' + (type.eventBookNotifyEmail || 'none')}
                                color="default"/>
                              <Chip
                                avatar={<Avatar><Icon>email</Icon></Avatar>}
                                size="small"
                                variant={'outlined'}
                                className={'m-1 mb-n1'}
                                label={'Cancellation: ' + (type.eventCancelNotifyEmail || 'none')}
                                color="default"/>

                              <small className={'text-small my-n2 d-block'}>
                                {type?.ongoingBooking && <Chip size="small"
                                                               className={'m-1 mb-n1'}
                                                               label={'Ongoing Booking'}
                                                               color="default"/>}
                                {type?.restrictedBooking && <Chip size="small"
                                                                  className={'m-1 mb-n1'}
                                                                  label={'Restricted Booking ' + type.restrictedBookingValue + ' ' + type.restrictedBookingName + 's'}
                                                                  color="default"/>}
                                {type.eventFormGk && type.eventFormGk > -1 &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label={'Form: ' + type.eventFormName}
                                    color="default"/>
                                }
                                {type.waiverGk && type.waiverGk > -1 &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label={'Waiver: ' + type.waiverName}
                                    color="default"/>
                                }

                                {type.guestWaiverGk && type.guestWaiverGk > -1 &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label={'Guest Waiver: ' + type.guestWaiverName}
                                    color="default"/>
                                }

                                {type.disableWaitlist &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label="Waitlist Disabled"
                                    color="info"/>
                                }

                                {type.privateAccess &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label="Private"
                                    color="info"/>
                                }

                                {type.requireAttendees &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label="Attendees Required"
                                    color="info"/>
                                }

                                {type.specialEvent &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label="Party Event"
                                    color="success"/>
                                }

                                {type.memberOnly &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label="Member Only"
                                    color="primary"/>
                                }

                                {type.siblingOptionsEnabled &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label={'Sibling Drop-In ' + formatCurrency(type.siblingDiscount)}
                                    color="primary"/>
                                }

                                {type.infantOptionsEnabled &&
                                  <Chip
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label={'Free Infant rate until ' + (type?.infantDiscountAge || 0) + ' months'}
                                    color="primary"/>
                                }

                                {type.specialRequest &&
                                  <Chip
                                    avatar={<Avatar><Icon>check</Icon></Avatar>}
                                    // deleteIcon={<Icon>check</Icon>}
                                    size="small"
                                    className={'m-1 mb-n1'}
                                    label="Party Requests"
                                    color="info"/>
                                }

                                {type.initialDeposit &&
                                  <Chip
                                    size="small"
                                    className={'m-2'}
                                    label={'Deposit: ' + type.depositPercent + '%'}
                                    color="secondary"/>
                                }
                                {type.initialDepositFee &&
                                  <Chip
                                    size="small"
                                    className={'m-2'}
                                    label={'Deposit: ' + formatCurrency(type.depositAmount)}
                                    color="secondary"/>
                                }
                              </small>

                              {
                                type.eventPackageGroups?.length > 0 && <span className="d-block">
                                <MDTypography variant="small" fontWeight={"light"}>Event Packages</MDTypography>
                                  <br/>
                                  {type.eventPackageGroups?.sort((a, b) => a.id - b.id).map((eventPackage, index) => {
                                    return (
                                      <Chip
                                        key={index}
                                        size="small"
                                        className={'m-1 mb-n1'}
                                        index={index}
                                        avatar={<Avatar
                                          src={eventPackage?.inventory?.imageThumbUrl || eventPackage?.inventory?.imageUrl}/>}
                                        label={eventPackage?.inventory?.name}
                                        variant="outlined"
                                        color="secondary"/>
                                    )
                                  })
                                  }
                                </span>
                              }

                              {
                                type.eventInventoryGroups?.length > 0 && <span className="d-block">
                                  <MDTypography variant="small" fontWeight={"light"}>Event Add-Ons</MDTypography>
                                  <br/>
                                  {type.eventInventoryGroups?.sort((a, b) => a.id - b.id).map((group, index) => {
                                    return (
                                      <Chip
                                        key={index}
                                        size="small"
                                        className={'m-1 mb-n1'}
                                        index={index}
                                        avatar={<Avatar
                                          src={group?.inventory.imageThumbUrl || group?.inventory.imageUrl}/>}
                                        label={group?.inventory.name}
                                        variant="outlined"
                                        color="secondary"/>
                                    )
                                  })
                                  }
                              </span>
                              }
                            </li>
                          )
                        })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <div id="event-packages" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <EventPackages savingCompany={savingCompany} />
                </Grid>

                <Grid item xs={12}>
                  <div id="event-locations" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Event Locations
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addEventLocationFn();
                          }}>
                          <Icon>room</Icon>&nbsp;Add Event Location
                        </MDButton>


                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right mx-2'}
                          onClick={(e) => {
                            setSortLocations(true);
                          }}>
                          <Icon>sort</Icon>&nbsp;Sort Locations
                        </MDButton>

                      </h5>
                      <p className={'py-2 fw-light'}>
                        Use event locations to separate party rooms or event spaces. For example, you might have
                        event locations for "Main Room", "Party Room A", "Party Room B", "Outdoor Space", etc.
                      </p>
                      <ul className={'list-group'}>
                        {eventLocations?.map((location, index) => {
                          return (
                            <li
                              className={'list-group-item'}
                              key={index}>
                              {location.id <= -1 && location.name}
                              {location.id > -1 && location.name &&
                                <>
                                 <span className="d-block pull-right">
                                    <EventLocationActions item={location}/>
                                  </span>
                                  <a
                                    href={'#'}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      manageEventLocationFn(location);
                                    }}>{location?.parentLocation ? <span className="mr-1"><Icon>star</Icon></span> : ''}
                                    {location.name}
                                  </a>
                                </>
                              }
                              {location.desc &&
                                <span className={'d-block'}>
                                  <small>{location.desc}</small>
                                </span>
                              }
                              {location.address && <>
                                <span className={'d-block'}><Icon>room</Icon><small>{location.address}</small></span>
                              </>}

                            </li>
                          );
                        })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <div id="age-ranges" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Age Ranges
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addAgeRangeTypFn();
                          }}>
                          <Icon>margin</Icon>&nbsp;Add Age Range
                        </MDButton>

                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right mx-2'}
                          onClick={(e) => {
                            setSortAgeRangeTypes(true);
                          }}>
                          <Icon>sort</Icon>&nbsp;Sort Age Ranges
                        </MDButton>

                      </h5>
                      <p className={'py-2 fw-light'}>
                        Use age ranges to customize events tailored to specific age groups. For
                        example, you might have age ranges for "0-2", "3-5", "5-10", "All Ages."
                      </p>
                      <ul className={'list-group'}>
                        {ageRangeTypes
                          .map((type, index) => {
                            return (
                              <li
                                className={'list-group-item '}
                                key={index}>
                                {type.id <= -1 && type.name}
                                {type.id > -1 && type.name &&
                                  <>
                                <span className="d-block pull-right">
                                    <AgeTypeActions item={type}/>
                                  </span>
                                    <a
                                      href={'#'}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        manageAgeRangeTypFn(type);
                                      }}>{type.name}</a>
                                    <small className={'text-small my-n2 d-block'}>
                                      {displayAgeRange(type) && <Chip
                                        size="small"
                                        className={'m-1 mb-n1'}
                                        label={displayAgeRange(type)}
                                        color="primary"/>
                                      }
                                    </small>

                                  </>
                                }
                              </li>
                            );
                          })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <div id="account-types" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Account Types
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addAccountTypeFn();
                          }}>
                          <Icon>apps</Icon>&nbsp;Add Account Type
                        </MDButton>

                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right mx-2'}
                          onClick={(e) => {
                            setSortAccountTypes(true);
                          }}>
                          <Icon>sort</Icon>&nbsp;Sort Account Types
                        </MDButton>
                      </h5>
                      <p className={'py-2 fw-light'}>
                        Use account types to define membership account types and their access to event categories. For
                        example, you might have
                        account types for "Annual Member", "Recurring Monthly Member", "Daily Drop In Customer",
                        "Party Event Account type", etc.
                        <br/><b>Note</b>: Multiple Account types may be mapped to multiple Event Types.
                      </p>
                      <ul className={'list-group'}>
                        {accountTypes.map((type, index) => {
                          return (
                            <li
                              className={'list-group-item '}
                              key={index}>
                              {type.id <= -1 && type.name}
                              {type.id > -1 && type.name &&
                                <>
                                <span className="d-block pull-right">
                                    <AccountTypeActions item={type}/>
                                  </span>

                                  <a
                                    href={'#'}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      manageAccountTypeFn(type);
                                    }}>{type.name}</a>

                                </>
                              }

                              {type.desc && <>
                                <small className={'text-small my-n2'}><br/>{type.desc}</small>
                              </>}

                              <small className={'text-small my-n2 d-block'}>
                                {!type?.familyPass && <Chip
                                  size="small"
                                  className={'m-1 mb-n1'}
                                  label={'Single Child Pass'}
                                  color="primary"/>
                                }
                                {type?.familyPass && <Chip
                                  size="small"
                                  className={'m-1 mb-n1'}
                                  label={'Family'}
                                  color="info"/>
                                }
                                {type?.siblingOptionsEnabled && <Chip
                                  size="small"
                                  className={'m-1 mb-n1'}
                                  label={'Sibling Discount ' + formatCurrency(type?.siblingDiscount)}
                                  color="primary"/>
                                }
                              </small>

                            </li>
                          );
                        })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <div id="referral-types" style={{
                    position: 'relative',
                    left: '-999em',
                    zIndex: '-999',
                    top: '-100px'
                  }}/>
                  <Card>
                    <MDBox p={3}>
                      <h5>
                        Referral Types
                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right'}
                          onClick={(e) => {
                            addReferralTypeFn();
                          }}>
                          <Icon>chat</Icon>&nbsp;Add Referral Type
                        </MDButton>

                        <MDButton
                          color="secondary"
                          size="small"
                          className={'pull-right mx-2'}
                          onClick={(e) => {
                            setSortReferralTypes(true);
                          }}>
                          <Icon>sort</Icon>&nbsp;Sort Referral Types
                        </MDButton>

                      </h5>
                      <p className={'py-2 fw-light'}>
                        Use referral types to customize and track customer sources. For
                        example, you might have referral types for "Direct Referral", "Online Search", and
                        "Local Advertisement"
                      </p>
                      <ul className={'list-group'}>
                        {referralTypes
                          .map((type, index) => {
                            return (
                              <li
                                className={'list-group-item '}
                                key={index}>
                                {type.id <= -1 && type.name}
                                {type.id > -1 && type.name &&
                                  <>
                                <span className="d-block pull-right">
                                    <ReferralTypeActions item={type}/>
                                  </span>
                                    <a
                                      href={'#'}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        manageReferralTypeFn(type);
                                      }}>{type.name}</a>
                                  </>
                                }
                              </li>
                            );
                          })}
                      </ul>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      {portalHelp && <Modal size={'lg'}
                            show={portalHelp}
                            onHide={() => {
                              setPortalHelp(false);
                            }}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Portal Host Snippet
          </Modal.Title>
        </Modal.Header>


        <ModalBody>
          <MDTypography variant="p" fontWeight="light">
            Copy and paste the below snippet into your hosted portal page where you want the portal to display.
          </MDTypography>
          <div sx={{mt: 2}}>
            <textarea id="embedCopy" defaultValue={portalEmbedCode()}
                      style={{
                        visibility: 'hidden',
                        position: 'absolute',
                        left: '-999em',
                        height: 0,
                        width: 0
                      }}
            />
            <pre
              onClick={() => {
                doCopySnippet()
              }}
              style={{
                whiteSpace: 'pre-wrap',
                padding: '10px',
                border: 'solid 1px #ccc'
              }}>{portalEmbedCode()}
            </pre>
            <MDButton color="info"
                      size="small"
                      className={'pull-right'}
                      onClick={() => {
                        doCopySnippet()
                      }}>Copy to clipboard</MDButton>
          </div>
        </ModalBody>
      </Modal>}

      {isManageCompanyDetailsModal
        && <ManageCompanyDetailsModal
          show={isManageCompanyDetailsModal}
          saving={savingCompany}
          handleSave={saveCompanyDetailsFn}
          handleClose={closeManageCompanyDetailsFn}
        />
      }
      {manageInventoryType && <ManageInventoryTypeModal
        inventoryType={inventoryType}
        show={manageInventoryType}
        saving={savingCompany}
        cafeMode={cafeMode}
        handleSave={saveInventoryTypeFn}
        handleClose={closeInventoryTypeFn}/>}

      {sortInventoryTypes && <SortInventoryTypes
        inventoryTypes={inventoryTypes}
        show={sortInventoryTypes}
        saving={savingCompany}
        handleSave={handleSaveInventoryTypesSort}
        handleClose={closeInventoryTypeSortFn}/>}

      {sortAccountTypes && <SortAccountTypes
        accountTypes={accountTypes}
        show={sortAccountTypes}
        saving={savingCompany}
        handleSave={handleSaveAccountTypesSort}
        handleClose={closeAccountTypeSortFn}/>
      }

      {sortAgeRangeTypes && <SortAgeRangeTypes
        ageRangeTypes={ageRangeTypes}
        show={sortAgeRangeTypes}
        saving={savingCompany}
        handleSave={handleSaveAgeRangeTypesSort}
        handleClose={closeAgeRangeTypeSortFn}/>
      }

      {sortReferralTypes && <SortReferralTypes
        referralTypes={referralTypes}
        show={sortReferralTypes}
        saving={savingCompany}
        handleSave={handleSaveReferralTypesSort}
        handleClose={closeReferralTypeSortFn}/>
      }

      {sortLocations && <SortLocations
        locations={eventLocations}
        show={sortLocations}
        saving={savingCompany}
        handleSave={handleSaveLocationsSort}
        handleClose={closeLocationsSortFn}/>
      }

      {sortEventTypes && <SortEventTypes
        eventTypes={inventoryEventTypes}
        show={sortEventTypes}
        saving={savingCompany}
        handleSave={handleSaveEventTypesSort}
        handleClose={closeInventoryEventTypeSortFn}/>}

      {manageInventoryEventType && <ManageInventoryEventTypeModal
        inventoryEventType={inventoryEventType}
        show={manageInventoryEventType}
        saving={savingCompany}
        handleSave={saveInventoryEventTypeFn}
        handleClose={closeInventoryEventTypeFn}/>}

      {manageAccountType && <ManageAccountTypeModal
        accountType={accountType}
        show={manageAccountType}
        saving={savingCompany}
        handleSave={saveAccountTypeFn}
        handleClose={closeAccountTypeFn}/>}

      {manageTipType && <ManageTipTypeModal
        tipType={tipType}
        show={manageTipType}
        saving={savingCompany}
        handleSave={saveTipTypeFn}
        handleClose={closeTipTypeFn}/>}

      {manageCashDrawer && <ManageCashDrawer
        drawer={cashDrawer}
        show={manageCashDrawer}
        saving={savingCompany}
        handleSave={saveCashDrawerFn}
        handleClose={closeDrawer}/>}

      {manageAgeRangeType && <ManageAgeRangeTypeModal
        ageRangeType={ageRangeType}
        show={manageAgeRangeType}
        saving={savingCompany}
        handleSave={saveAgeRangeTypeFn}
        handleClose={closeAgeRangeTypeFn}/>}

      {manageReferralType && <ManageReferralTypeModal
        referralType={referralType}
        show={manageReferralType}
        saving={savingCompany}
        handleSave={saveReferralTypeFn}
        handleClose={closeReferralTypeFn}/>}

      {manageEmailCredential && <ManageEmailCredential
        credential={emailCredential}
        show={manageEmailCredential}
        handleSave={() => {
          let _context = {...context};
          const toastMessage = 'Email Credential save successful.';
          _context.toast = {
            message: toastMessage,
            type: 'success'
          }
          setContext({..._context});
          setManageEmailCredential(false);
          setEmailCredential(null);
          loadCredentialTypes();
          loadCompanyCredentials();
        }}
        handleClose={() => {
          setManageEmailCredential(false);
          setEmailCredential(null);
        }}/>}

      {manageSmsCredential && <ManageExtCredential
        type={'SMS'}
        typeId={CONSTANTS.EXT_CREDENTIAL.SMS}
        credential={extCredential}
        show={manageSmsCredential}
        handleSave={() => {
          let _context = {...context};
          const toastMessage = 'SMS Credential save successful.';
          _context.toast = {
            message: toastMessage,
            type: 'success'
          }
          setContext({..._context});
          setManageSmsCredential(false);
          setExtCredential(null);
          loadCredentialTypes();
          loadCompanyCredentials();
        }}
        handleClose={() => {
          setManageEmailCredential(false);
          setEmailCredential(null);
        }}/>}

      {syncSquareDevice && <SyncSquareDeviceModal
        show={syncSquareDevice}
        handleSave={(e) => {
          let _context = {...context};
          const toastMessage = 'Square Sync successful.';
          _context.toast = {
            message: toastMessage,
            type: 'success'
          }
          setContext({..._context});
          setSyncSquareDevice(false);
          getCompanyExtAppData();
        }}
        handleClose={(e) => {
          setSyncSquareDevice(false);
        }}/>}

      {manageHomeLocation && <MangeSquareHomeLocation
        show={manageHomeLocation}
        handleClose={() => {
          setManageHomeLocation(false);
        }}
        handleSave={(e) => {
          let _context = {...context};
          const toastMessage = 'Home Location successfully saved.';
          _context.toast = {
            message: toastMessage,
            type: 'success'
          }
          setContext({..._context});
          setManageHomeLocation(false);
          getCompanyExtAppData();
        }}
      />}

      {manageEventLocation && <ManageEventLocationModal
        eventLocation={eventLocation}
        show={manageEventLocation}
        saving={savingCompany}
        handleSave={saveEventLocationFn}
        handleClose={closeEventLocationFn}/>}

      {confirmDelete && <Confirm confirmation={confirmation}
                                 show={confirmDelete}
                                 saving={saving}
                                 handleConfirm={handleArchiveEventCategory}
                                 handleSave={handleCloseDeleteInventory}
                                 handleClose={handleCloseDeleteInventory}/>}

      {confirmDeleteInventoryType && <Confirm confirmation={confirmation}
                                              show={confirmDeleteInventoryType}
                                              saving={saving}
                                              handleConfirm={handleArchiveInventoryType}
                                              handleSave={handleCloseInventoryType}
                                              handleClose={handleCloseInventoryType}/>}

      {confirmDeleteAccountType && <Confirm confirmation={confirmation}
                                            show={confirmDeleteAccountType}
                                            saving={saving}
                                            handleConfirm={handleArchiveAccountType}
                                            handleSave={handleCloseAccountType}
                                            handleClose={handleCloseAccountType}/>}

      {confirmDeleteAgeType && <Confirm confirmation={confirmation}
                                        show={confirmDeleteAgeType}
                                        saving={saving}
                                        handleConfirm={handleArchiveAgeType}
                                        handleSave={handleCloseAgeType}
                                        handleClose={handleCloseAgeType}/>}

      {confirmDeleteTipType && <Confirm confirmation={confirmation}
                                        show={confirmDeleteTipType}
                                        saving={saving}
                                        handleSave={handleCloseTipType}
                                        handleConfirm={handleArchiveTipType}
                                        handleClose={handleCloseTipType}/>}

      {confirmDeleteRegister && <Confirm confirmation={confirmation}
                                         show={confirmDeleteRegister}
                                         saving={saving}
                                         handleSave={handleCloseRegisterType}
                                         handleConfirm={handleArchiveRegister}
                                         handleClose={handleCloseRegisterType}/>}

      {confirmDeleteReferralType && <Confirm confirmation={confirmation}
                                             show={confirmDeleteReferralType}
                                             saving={saving}
                                             handleSave={() => {
                                               setConfirmDeleteReferralType(false)
                                             }}
                                             handleConfirm={handleArchiveReferralType}
                                             handleClose={() => {
                                               setConfirmDeleteReferralType(false)
                                             }}/>}

      {confirmDeleteLocation && <Confirm confirmation={confirmation}
                                         show={confirmDeleteLocation}
                                         saving={saving}
                                         handleSave={handleCloseLocation}
                                         handleConfirm={handleDeleteLocation}
                                         handleClose={handleCloseLocation}/>}

      {confirmDeleteCredential && <Confirm confirmation={confirmation}
                                           show={confirmDeleteCredential}
                                           saving={saving}
                                           handleSave={() => {
                                             setConfirmDeleteCredential(false);
                                             setConfirmation(null);
                                           }}
                                           handleConfirm={handleRemoveEmailCredentialFn}
                                           handleClose={() => {
                                             setConfirmDeleteCredential(false);
                                             setConfirmation(null);
                                           }}/>}

      <Footer mt={5}/>

    </DashboardLayout>
  );
}